// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"cdc10e91","349":"4346091c"}[chunkId] + ".chunk.js";
};